<!-- 文件上传组件 -->
<template>
	<div class="file-upload">
		<el-input :placeholder="placeholder" :value="fileName" readonly="readonly" :disabled="disabled">
			<template slot="append">
				<el-upload
					:on-success="onSuccess"
					:on-error="onError"
					class="upload-demo"
					:action="`${domain}/upload`"
					:headers="headers"
					:show-file-list="false"
					list-type="text"
					:before-upload="beforeUpload"
					:loading="loading"
					:on-change="fileChange"
					:file-list="fileList"
					:accept="accept"
					:disabled="disabled"
					with-credentials
				>
					<el-button
						size="small"
						type="primary"
						:loading="loading" style="color:#1FA0E8;"
					>{{$t('components.upload.uploadField')}}</el-button>
				</el-upload>
			</template>
		</el-input>
		<span class="file-template" v-if="showFileTemplate" @click="downLoad">
      <i class="el-icon-download"></i> {{ $t('components.upload.download') }}{{templateInfoFileName}}
    </span>
	</div>
</template>

<script>
export default {
	name: "fileUpload",
	props: {
		placeholder: {
			type: String,
			default: ""
		},
		value: {
			type: Array,
			default: function() {
				return [];
			}
		},
		templateInfo: {
			type: Object,
			default: function() {
				return {};
			}
		},
		disabled: {
			type: Boolean,
			default: false
		},
		accept: {
			type: String,
			default: ".pdf,.xlsx,.xls,.xlsm,.xltx,.xltm,.xlsb,.xlam"
		},
		region: {
			type: String,
			default: "eu"
		},
	},
	data: function() {
		return {
			loading: false,
			fileList: [],
			fileName: "",
			domain: this.getMerchantFilesUrl(),
			key: "",
			processLenth: 0,
			lang: this.$i18n.locale,
			headers: {
				accessToken: window.sessionStorage.getItem('accessToken')
			}
		};
	},

	computed: {
		templateInfoFileName() {
			if(this.lang === 'en') {
				return this.templateInfo.otherFileName || this.templateInfo.fileName
			}
			return this.templateInfo.fileName
		},
		templateInfoFilePath() {
			if(this.lang === 'en') {
				return this.templateInfo.otherFilePath || this.templateInfo.filePath
			}
			return this.templateInfo.filePath
		},
		showFileTemplate() {
			if (this.templateInfoFileName) {
				return true;
			} else {
				return false;
			}
		},
	},
	watch: {
		value: {
			handler: function(val, oldVal) {
				if (val.length > 0) {
					this.fileName = val[0].filePath;
				} else {
					this.fileName = "";
				}
			},
			immediate: true,
			deep: true
		}
	},

	methods: {
		onSuccess(response, file, fileList) {
			this.loading = false;
			const { code = "", data = {} } = response;
			const { fileName } = data;
			if (code !== 200 && fileName) {
				this.$message.error(this.$t("components.upload.uploadFail"));
			} else {
				this.fileName = fileName;
				this.$emit("input", [{ fileName, filePath: fileName, type: "EXCEL" }]);
			}
		},
		onError() {
			this.$emit("input", []);
			this.$message({
				type: "error",
				message: "Failed to upload, please re-upload..."
			});
		},
		beforeUpload(file) {
			this.loading = true;
		},
		// 下载
		downLoad() {
			const key = this.getCookie("fs_merchant");
			const domain = this.getEnv();
			window.location.href = `${domain}/file/eu/downLoad/${this.templateInfoFilePath}?app=merchant&key=${key}`;
		},

		fileChange(file) {
			if (file.status === "ready") {
				const interval = setInterval(() => {
					if (this.processLenth > 97) {
						clearInterval(interval);
						return;
					}
					this.processLenth += Math.ceil(Math.random() * 3);
					this.$emit("percent", this.processLenth);
				}, 30);
			} else if (file.status === "success") {
				this.processLenth = 100;
				this.$emit("percent", this.processLenth);
				setTimeout(() => {
					this.processLenth = 0;
					this.$emit("percent", this.processLenth);
				}, 500);
			}
		}
	},
};
</script>
<style lang="scss" scoped>
::v-deep.file-upload {
	::v-deep .el-input-group__append,
	.el-input-group__prepend {
		color: #3a8ee6 !important;
		background-color: transparent;
		border-top-right-radius: 20px !important;
		border-bottom-right-radius: 20px !important;
	}

	.el-upload {
		display: flex;
	}
	input {
		outline: none;
	}
	::v-deep .el-input__inner {
		border-right: none !important;
		border-top-left-radius: 20px !important;
		border-bottom-left-radius: 20px !important;
		white-space: nowrap; /* 使文本不可换行 */
		overflow: hidden; /* 隐藏溢出部分 */
		text-overflow: ellipsis;
	}

	.file-template {
		color: #3a8ee6;
    cursor: pointer;
	}
	.el-input.is-active .el-input__inner,
	.el-input__inner:focus {
		border-color: #dcdfe6;
	}
	.el-input__inner:hover {
		border-color: #dcdfe6;
	}
}
</style>
